module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('reservations-wrapper', {
    attrs: {
      "rows": _vm.reservationsArr,
      "isLoading": _vm.isLoadingReservations,
      "hasLoadedOnce": _vm.hasLoadedOnce,
      "pageInfo": _vm.pageInfo,
      "header": _vm.header,
      "body": _vm.body,
      "paginationValue": _vm.paginationComputed,
      "resultsPerPage": _vm.resultsPerPage,
      "resultsPerPageOptions": _vm.resultsPerPageOptions,
      "allowSelectRows": _vm.allowSelectRows,
      "bulkInvoiceTotal": _vm.bulkInvoiceTotal,
      "initialTab": _vm.selectedTab
    },
    on: {
      "page-change": _vm.onPageChange,
      "results-per-page-change": _vm.onResultsPerPageChange
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-41890075", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41890075"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/ReservationsBySaleDate.vue
// module id = 2806
// module chunks = 0